module.exports = __webpack_public_path__ + "img/stories-tablet-arabic.7d74b62a.png";